export default function BigLineMosaic() {
    return (
        <svg width="100%" height="100%" viewBox="0 0 1000 1000" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_2413_1811)">
                <rect width="100%" height="100%" fill="#FFC525" />
                <path d="M1000 0H0V1000H1000V0Z" fill="#FF89C2" />
                <path d="M500 0H0V500L500 0Z" fill="#FFC525" />
                <path d="M500 1000H1000V500L500 1000Z" fill="#FFC525" />
            </g>
            <defs>
                <clipPath id="clip0_2413_1811">
                    <rect width="100%" height="100%" fill="white" />
                </clipPath>
            </defs>
        </svg>

    )
}